import { createContext } from 'react';

import { stores } from '../stores';

const StoresContext = createContext<typeof stores>(stores);

const StoreProvider = StoresContext.Provider;

export { StoresContext, StoreProvider };
